import { createRouterSelector } from 'react-resource-router';

import { useNoOrgExperience } from '@townsquare/org-context';
import { HomepageRoute } from '@townsquare/router/route-types';
import { useNoWorkspaceExperience } from '@townsquare/workspace-store';

import { noWorkspaceRoutes, routes } from './routes';

export const useRoute = createRouterSelector<HomepageRoute>(o => o.route as HomepageRoute);
export const useOutlet = createRouterSelector<HomepageRoute['outlet']>(o => (o.route as HomepageRoute).outlet);

export const useHomeRoutes = () => {
  const noOrgExperience = useNoOrgExperience();
  const noWorkspaceExperience = useNoWorkspaceExperience();
  return noOrgExperience || noWorkspaceExperience ? noWorkspaceRoutes : routes;
};
